const colors: Colors = {
  // Main colors
  primary_blue: '#0053A1',
  primary_turquoise: '#0A80A8',
  primary_emeraude: '#1F8389',
  primary_green: '#3A8641',
  secondary_lightGreen: '#57A37C',
  secondary_grey: '#6A6A6A',
  secondary_yellow: '#FAB200',
  // Text
  primary_text: '#000000',
  secondary_text: '#FFFFFF',
  // --- Components ---
  // Button
  actionButton01: '#33873A',
  actionButton02: '#006E09',
  actionButtonshadow: '#2D793359',
  navigationButton01: '#0A80A8',
  navigationButton02: '#0053A1',
  navigationButtonShadow: '#0A80A859',
  classicButton: '#FFFFFF',
  classicButtonBorder: '#0053A1',
  classicButtonLoader: '#0053A1',
  mapButtonLoader: '#0053A1',
  disabledButton: '#CCCCCC',
  buttonLoader: '#FFFFFF',
  // Card
  cardBackground: '#FFFFFF',
  cardShadow: '#1E4B7333',
  // Menu
  menuBackground: '#FFFFFF',
  menuShadow: '#1E4B7399',
  menuBorder: '#f1f1f1',
  // Searchbar
  iconColor: '#0053A1',
  searchbarBackground: '#FFFFFFCC',
  searchbarBorder: '#919191',
  // Chantier item
  chantierBorder: '#f1f1f1',
  chantierHoverBackground: '#C3C3C333',
  titleColor: '#2D2A26',
  subtitleColor: '#6A6A6A',
  libelleColor: '#2D2A26',
  // Filter
  filterBackgroundColor: '#F8F6F5',
  filterPrimarycolor: '#0053A1',
  filterSecondaryColor: '#FFFFFF',
  filterPrimaryBackground: '#0053A177',
  filterSecondaryBackground: '#0053A133',
  backgroundColor: '#2D2A2666',
  // Marker
  markerInProgress: '#006E09',
  markerStopped: '#FAB200',
  markerEnded: '#9494A2',
  markerBackground: '#FFFFFF',
  // Details Business
  backgroundSelected: '#0053A126',
  greyBackground: '#F1EFEE',
  // No location information
  noLocationContainer: '#2D793359',
  noLocationIcon: '#FAB200',
  maplegend: {
    inprogress: '#006E09',
    stopped: '#FAB200',
    orphans: '#D60000',
    clusters: '#0053A1',
  },
  // MultiSelect
  disabled: '#D8D8D8',

  // Pagination
  greyBorder: '#E5E7EB',
  greyFont: '#6b7280',
  light_primary_blue: '#0053A111',

  // Admin data
  dataMenuColor: '#919191',
  dataChoiceBackground: '#F1EFEE',
  selectionItemSelected: '#0053A1',
  selectionItemUnselected: '#FFFFFF',
  selectionLibelleSelected: '#F1EFEE',
  selectionLibelleUnselected: '#0053A1',
  selectionSecondaryItemSelected: '#0A80A8',
  selectionSecondaryItemUnselected: '#FFFFFF',
  selectionSecondaryLibelleSelected: '#F1EFEE',
  selectionSecondaryLibelleUnselected: '#0A80A8',
  selectionTertiaryItemSelected: '#1F8389',
  selectionTertiaryItemUnselected: '#FFFFFF',
  selectionTertiaryLibelleSelected: '#F1EFEE',
  selectionTertiaryLibelleUnselected: '#1F8389',

  // CSV Tab
  headerBackgroundColor: '#57A37C',
  headerColor: '#FFFFFF',
  oddBackgroundColor: '#F8F6F5',
  oddColor: '#000000',
  tabBackgroundColor: '#FFFFFF',
  tabColor: '#000000',
  tabError: '#D60000',
  tabSuccess: '#006E09',
}

const theme: Theme = {
  colors: {
    ...colors,
  },
  fonts: {
    title: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontSize: '20px',
      lineHeight: '24px',
      fontWeight: 900,
      color: colors.primary_blue,
    },
    label: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontSize: '17px',
      lineHeight: '21px',
      fontWeight: 200,
      color: colors.primary_text,
    },
    boldLabel: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontSize: '17px',
      lineHeight: '21px',
      fontWeight: 900,
      color: colors.primary_text,
    },
    buttonBig: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 300,
      color: colors.secondary_text,
    },
    buttonMedium: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontSize: '14px',
      lineHeight: '19px',
      fontWeight: 300,
      color: colors.secondary_text,
    },
    buttonSmall: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontSize: '12px',
      lineHeight: '24px',
      fontWeight: 300,
      color: colors.secondary_text,
    },
    chantierTitle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontSize: '16px',
      lineHeight: '16px',
      fontWeight: 800,
      fontStyle: 'normal',
      color: colors.titleColor,
    },
    chantierSubTitle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: 500,
      fontStyle: 'normal',
      color: colors.subtitleColor,
    },
    chantierLibelle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: 'normal',
      fontStyle: 'normal',
      color: colors.libelleColor,
    },
    filterLibelle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '12px',
      lineHeight: '16px',
      color: colors.filterPrimarycolor,
    },
    lonelyPictureLibelle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '12px',
      lineHeight: '16px',
      color: colors.filterPrimarycolor,
    },
    selectLibelle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '22px',
      color: colors.secondary_grey,
    },
    calendarLibelle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontWeight: 900,
      fontSize: '16px',
      lineHeight: '22px',
      color: colors.filterPrimarycolor,
    },
    calendarLibelle01: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontWeight: 900,
      fontSize: '14px',
      lineHeight: '22px',
      color: '#2D2A26',
    },
    calendarLibelle02: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontWeight: 900,
      fontSize: '14px',
      lineHeight: '19px',
      color: '#2D2A26',
    },
    calendarLibelle03: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontWeight: 900,
      fontSize: '14px',
      lineHeight: '19px',
      color: '#9494A2',
    },
    calendarLibelle04: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '22px',
      color: '#6A6A6A',
    },
    checkboxesTitle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '22px',
      color: '#0053A1',
    },
    checkboxLibelle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '19px',
      color: '#0053A1',
    },
    noItem: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '14px',
      color: '#9494A2',
    },
    markerLibelle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontWeight: 900,
      fontSize: '18px',
      lineHeight: '24px',
      color: '#9494A2',
    },
    backLibelle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontWeight: 200,
      fontSize: '14px',
      lineHeight: '16px',
      color: '#9494A2',
    },
    chantierMenuTitle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      lineHeight: '22px',
      fontWeight: 500,
      fontSize: '16px',
      color: '#2d2a26',
    },
    chantierMenuSubtitle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      lineHeight: '22px',
      fontWeight: 500,
      fontSize: '16px',
      color: '#2d2a26',
    },
    chantierMenuLibelle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '22px',
      color: '#2d2a26',
    },
    chantierMenuItem: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '22px',
      color: '#2d2a26',
    },
    declarationCounter: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontWeight: 900,
      fontSize: '16px',
      lineHeight: '19px',
      color: '#2d2a26',
    },
    errorLibelle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontWeight: 200,
      fontSize: '16px',
      lineHeight: '19px',
      color: '#FF0000',
    },
    noLocationTitle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '20px',
      lineHeight: '25px',
      color: '#2d2a26',
    },
    noLocationDescription: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontWeight: 200,
      fontSize: '14px',
      lineHeight: '19px',
      color: '#2d2a26',
    },
    versionLibelle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontWeight: 900,
      fontSize: '12px',
      lineHeight: '10px',
      color: '#ffffff',
    },
    pagination: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'normal',
      fontSize: '14px',
      color: colors.greyFont,
    },
    sectionTitle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontSize: '20px',
      fontStyle: 'normal',
      fontWeight: 900,
      lineHeight: '24px',
      color: colors.primary_blue,
    },
    selectorTitle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 900,
      lineHeight: '19px',
      color: '#9494A2',
    },
    bigTitle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontSize: '32px',
      lineHeight: '36px',
      fontWeight: 900,
      color: colors.primary_blue,
    },
    failedGeolocLibelle: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontSize: '12px',
      fontWeight: 'normal',
      fontStyle: 'italic',
      color: colors.primary_blue,
    },
    idPrestataire: {
      fontFamily: 'Avenir, -webkit-pictograph',
      fontStyle: 'italic',
      fontWeight: 900,
      fontSize: '14px',
      color: colors.libelleColor,
    },
  },
  constants: {
    shadow: {
      shadowColor: '#000',
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.23,
      shadowRadius: 2.62,

      elevation: 4,
    },
  },
}

export default theme
